import { message } from "antd";
import axios from "axios";
import { errorActions } from "../helpers/auth_helper";

export interface BranchMember {
  id: number;
  user: User;
  branch: Branch[];
  category_name: any;
  department: string;
  designation: any;
  status: boolean;
  user_permission: number;
}

export interface User {
  id: string;
  roles: Roles;
  date_joined: string;
  show_priced_products: boolean;
  is_verified: boolean;
  last_login: any;
  is_superuser: boolean;
  md_user_id: any;
  f_name: string;
  l_name: any;
  email: string;
  company_name: any;
  profile_img: any;
  company_img: any;
  whatsapp_group_link: any;
  gst_number: any;
  coa_reg_no: any;
  pincode: number;
  city: any;
  other_profession: any;
  pan: any;
  company_address: any;
  contact: number;
  country_code: string;
  fcmToken: any;
  is_staff: boolean;
  is_active: boolean;
  migrated_id: any;
  referral_code: string;
  alternate_contact: any;
  alternate_email: any;
  created_at: string;
  modified_at: string;
  verification_status: any;
  user_source: string;
  channel: any;
  medium: any;
  md_project_id: any;
  zoho_customer_id: any;
  default_address: any;
  groups: any[];
  user_permissions: any[];
  profession: any[];
}

export interface Roles {
  id: number;
  name: string;
}

export interface Branch {
  id: number;
  branch_name: string;
  address: string;
  branch_head_designation: any;
  branch_head_name: any;
  branch_head_signature: any;
  bank_account_holder: string;
  bank_account_number: string;
  bank_ifsc: string;
  branch_upi: string;
  project_code_initials: string;
  project_code_format: string;
  project_code_seprator: string;
  po_number_initials: string;
  po_number_format: string;
  po_number_seprator: string;
  bid_number_initials: string;
  bid_number_format: string;
  bid_number_seprator: string;
  po_counter: number;
  bid_counter: number;
  estimate_number_initials: string;
  estimate_number_format: string;
  estimate_number_seprator: string;
  estimate_counter: number;
  estimate_trail_zero: number;
  lead_number_initials: string;
  lead_number_format: string;
  lead_number_seprator: string;
  lead_counter: number;
  inventory_number_initials: string;
  inventory_number_format: string;
  inventory_counter: number;
  qr_code: any;
  organisation_logo: string;
  payment_logo: string;
  access_token: string;
  status: boolean;
}

export const fetchBranches = async (branch_id = 1) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/orgainsation-branch/`, {
        params: {
          id: branch_id,
        },
      })
      .then((res) => {
        return res?.data?.[0] ?? null;
      })
      .catch((error) => {
        errorActions(
          error,
          "Error fetching branches. Please check and try again"
        );
        return;
      });
  } catch (error) {}
};

export const fetchAllBranches = async () => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/orgainsation-branch/`)
      .then((res) => {
        return res?.data ?? [];
      })
      .catch((error) => {
        errorActions(
          error,
          "Error fetching branches. Please check and try again"
        );
        return;
      });
  } catch (error) {}
};

export const fetchBranchTermAandConditions = async () => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/terms-and-condition/`)
      .then((res) => {
        return res?.data ?? [];
      })
      .catch((error) => {
        errorActions(
          error,
          "Error fetching branch terms and conditions. Please check and try again"
        );
        return;
      });
  } catch (error) {
    return null;
  }
};

export const fetchBranchGst = async () => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/gst/`)
      .then((res) => {
        return res?.data ?? [];
      })
      .catch((error) => {
        errorActions(
          error,
          "Error fetching branch gst. Please check and try again"
        );
        return;
      });
  } catch (error) {
    return null;
  }
};

export const addGstToBranch = async (values: any) => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/gst/`, {
        ...values,
        branch: 1,
      })
      .then((res) => {
        console.log("GST added", res);
        message.success("New gst added succesfully");
      })
      .catch((e) => {
        if (e?.response?.status == 400) {
          message.error("GST already added.");
          errorActions(e, "Error Occurred. Please try again");
        }
      });
  } catch (error) {}
};

export const deleteBranchGst = async (id: any) => {
  try {
    return axios
      .delete(`${process.env.REACT_APP_API_URL}/gst/${id}`)
      .then((res) => {
        console.log("GST deleted", res);
        message.success("Gst deleted succesfully");
      })
      .catch((e) => {
        errorActions(e, "Error Occurred. Please try again");
      });
  } catch (error) {}
};

export const editBranchGst = async (id: any, values: any, branch = 1) => {
  try {
    return axios
      .put(`${process.env.REACT_APP_API_URL}/gst/${id}/`, { ...values, branch: branch })
      .then((res) => {
        console.log("GST edited", res);
        message.success("Gst edited succesfully");
      })
      .catch((e) => {
        errorActions(e, "Error Occurred. Please try again");
      });
  } catch (error) {}
};

export const editBranchTerms = async (id: any, values: any, branch = 1) => {
  try {
    return axios
      .put(`${process.env.REACT_APP_API_URL}/terms-and-condition/${id}/`, { ...values, branch: branch })
      .then((res) => {
        message.success("Edited succesfully");
      })
      .catch((error) => {
        errorActions(error, "Error Occurred. Please check and try again");
        return;
      });
  } catch (error) {
    return null;
  }
};

export const deleteBranchTerms = async (id: any) => {
  try {
    return axios
      .delete(`${process.env.REACT_APP_API_URL}/terms-and-condition/${id}/`)
      .then((res) => {
        message.success("Deleted succesfully");
      })
      .catch((error) => {
        errorActions(error, "Error Occurred. Please check and try again");
        return;
      });
  } catch (error) {
    return null;
  }
};

export const addBranchTerms = async (values: any, branch = 1) => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/terms-and-condition/`, {
        ...values,
        branch,
      })
      .then((res) => {
        message.success("New terms added succesfully");
      })
      .catch((error) => {
        errorActions(error, "Error Occurred. Please check and try again");
        return;
      });
  } catch (error) {
    return null;
  }
};

const branchMembersCache: { [key: string]: { data: any; ts: number } } = {};
const branchMembersInFlight: { [key: string]: Promise<any> | undefined } = {};
const BRANCH_MEMBERS_TTL = 60 * 1000;

export const fetchBranchMembers = async (params?: any) => {
  const key = JSON.stringify(params ?? {});
  const cached = branchMembersCache[key];
  if (cached && Date.now() - cached.ts < BRANCH_MEMBERS_TTL) {
    return cached.data;
  }
  if (branchMembersInFlight[key]) {
    return branchMembersInFlight[key];
  }
  try {
    branchMembersInFlight[key] = axios
      .get(`${process.env.REACT_APP_API_URL}/user-organisation/`, {
        params: { ...params },
      })
      .then((res) => {
        const data = res?.data ?? [];
        branchMembersCache[key] = { data, ts: Date.now() };
        return data;
      })
      .catch((error) => {
        errorActions(
          error,
          "Error fetching branch members. Please check and try again"
        );
        return;
      })
      .finally(() => {
        delete branchMembersInFlight[key];
      });
    return branchMembersInFlight[key];
  } catch (error) {
    return null;
  }
};

export const addMemberToBranch = async (
  values: any,
  branch = 1
): Promise<boolean> => {
  try {
    return await axios
      .post(`${process.env.REACT_APP_API_URL}/user-organisation/`, {
        ...values,
        branch: [branch],
      })
      .then(() => {
        message.success("New member added successfully");
        return true;
      })
      .catch((e) => {
        if (e?.response?.status == 400) {
          message.error("User already added.");
          errorActions(e, "Error Occurred. Please try again");
        } else {
          errorActions(e, "Error Occurred. Please try again");
        }
        return false;
      });
  } catch (error) {
    return false;
  }
};

export const editMemberOfBranch = async (
  values: any,
  user_id: string
): Promise<boolean> => {
  try {
    return await axios
      .put(`${process.env.REACT_APP_API_URL}/user-organisation/` + user_id + "/", { ...values })
      .then(() => true)
      .catch((e) => {
        errorActions(e, "Error Occurred. Please try again");
        return false;
      });
  } catch (error) {
    return false;
  }
};

export const updateMemberPermissions = async (
  member_id: number,
  individual_permissions: string[],
  silent: boolean = false
): Promise<boolean> => {
  try {
    return await axios
      .put(
        `${process.env.REACT_APP_API_URL}/user-organisation/${member_id}/`,
        { individual_permissions }
      )
      .then(() => {
        if (!silent) message.success("Permissions updated successfully");
        return true;
      })
      .catch((e) => {
        errorActions(e, "Error updating permissions. Please try again");
        return false;
      });
  } catch (error) {
    return false;
  }
};

// Bulk add/remove permission slugs for every member of a role, in one atomic
// backend call. role_defaults seeds members whose individual_permissions is
// still null so they don't lose role-granted access. Returns updated count.
export const bulkUpdateRolePermissions = async (
  role: string,
  add: string[],
  remove: string[],
  role_defaults: string[]
): Promise<number | null> => {
  try {
    return await axios
      .put(
        `${process.env.REACT_APP_API_URL}/user-organisation/bulk-permissions/`,
        { role, add, remove, role_defaults }
      )
      .then((res) => {
        const n = res?.data?.updated ?? 0;
        message.success(`Updated ${n} ${role} member(s)`);
        return n as number;
      })
      .catch((e) => {
        errorActions(e, "Error applying bulk permissions. Please try again");
        return null;
      });
  } catch (error) {
    return null;
  }
};

// ---------------------------------------------------------------------------
// RBAC (server-side source of truth). These target the new backend endpoints:
//   - per-user deltas  -> PUT /user-organisation/<id>/ { granted/revoked }
//   - role matrix       -> GET|PUT /roles/<role>/permissions/
//   - catalogue         -> GET /permissions/catalog/
// ---------------------------------------------------------------------------

// Persist a member's per-user delta (grants beyond their role / revokes from it).
export const updateMemberDeltas = async (
  member_id: number,
  granted_permissions: string[],
  revoked_permissions: string[],
  silent: boolean = false
): Promise<boolean> => {
  try {
    return await axios
      .put(`${process.env.REACT_APP_API_URL}/user-organisation/${member_id}/`, {
        granted_permissions,
        revoked_permissions,
        // Retire the legacy flat list on first delta write so it can never
        // shadow the delta-resolved effective set on reload.
        individual_permissions: null,
      })
      .then(() => {
        if (!silent) message.success("Permissions updated successfully");
        return true;
      })
      .catch((e) => {
        errorActions(e, "Error updating permissions. Please try again");
        return false;
      });
  } catch (error) {
    return false;
  }
};

// The permission slugs a role grants by default (the DB matrix row).
export const fetchRolePermissions = async (
  role: string
): Promise<string[] | null> => {
  try {
    return await axios
      .get(`${process.env.REACT_APP_API_URL}/roles/${role}/permissions/`)
      .then((res) => (res?.data?.permissions as string[]) ?? [])
      .catch(() => null);
  } catch (error) {
    return null;
  }
};

// Replace a role's default permission set (admin-editable matrix).
export const updateRolePermissions = async (
  role: string,
  permissions: string[]
): Promise<boolean> => {
  try {
    return await axios
      .put(`${process.env.REACT_APP_API_URL}/roles/${role}/permissions/`, {
        permissions,
      })
      .then(() => {
        message.success(`Updated ${role} role permissions`);
        return true;
      })
      .catch((e) => {
        errorActions(e, "Error updating role permissions. Please try again");
        return false;
      });
  } catch (error) {
    return false;
  }
};

// Force every member of a role onto the role's exact defaults — clears all their
// per-user grant/revoke overrides. Returns the number of members reset, or null.
export const enforceRoleOnMembers = async (
  role: string
): Promise<number | null> => {
  try {
    return await axios
      .post(`${process.env.REACT_APP_API_URL}/roles/${role}/enforce/`, {})
      .then((res) => {
        const n = res?.data?.members_reset ?? 0;
        message.success(`Reset ${n} ${role} member(s) to the role`);
        return n as number;
      })
      .catch((e) => {
        errorActions(e, "Error enforcing role on members. Please try again");
        return null;
      });
  } catch (error) {
    return null;
  }
};

// The full permission catalogue (slug + entity/action + label + description +
// category/entity_label/sort_order) — the single source the admin grid is built from.
export const fetchPermissionCatalog = async (): Promise<any[] | null> => {
  try {
    return await axios
      .get(`${process.env.REACT_APP_API_URL}/permissions/catalog/`)
      .then((res) => res?.data ?? [])
      .catch(() => null);
  } catch (error) {
    return null;
  }
};

// Create a new permission at runtime — no migration, no code. `entity`/`action`
// default from the slug ("module.action") when omitted.
export const createPermission = async (payload: {
  slug: string;
  label?: string;
  description?: string;
  category?: string;
  entity?: string;
  entity_label?: string;
  action?: string;
  sort_order?: number;
}): Promise<any | null> => {
  try {
    return await axios
      .post(`${process.env.REACT_APP_API_URL}/permissions/catalog/`, payload)
      .then((res) => {
        message.success(`Created permission "${payload.slug}"`);
        return res?.data ?? null;
      })
      .catch((e) => {
        errorActions(e, "Error creating permission. Please try again");
        return null;
      });
  } catch (error) {
    return null;
  }
};

// Edit a permission's label / description / grouping.
export const updatePermission = async (
  slug: string,
  patch: Record<string, any>
): Promise<any | null> => {
  try {
    return await axios
      .patch(`${process.env.REACT_APP_API_URL}/permissions/${slug}/`, patch)
      .then((res) => {
        message.success("Permission updated");
        return res?.data ?? null;
      })
      .catch((e) => {
        errorActions(e, "Error updating permission. Please try again");
        return null;
      });
  } catch (error) {
    return null;
  }
};

// Deactivate a permission (drops it from the catalogue without orphaning grants).
export const deactivatePermission = async (slug: string): Promise<boolean> => {
  try {
    return await axios
      .delete(`${process.env.REACT_APP_API_URL}/permissions/${slug}/`)
      .then(() => {
        message.success("Permission deactivated");
        return true;
      })
      .catch((e) => {
        errorActions(e, "Error deactivating permission. Please try again");
        return false;
      });
  } catch (error) {
    return false;
  }
};

export interface BmTransferClient {
  name: string;
  contact: number;
}

export interface BmTransferResult {
  source_bm_org_id: number;
  dest_bm_org_id: number;
  source_bm_name: string;
  dest_bm_name: string;
  clients_transferred: number;
  assignments_created: number;
  assignments_reactivated: number;
  tickets_reassigned: number;
  estimates_reassigned: number;
  clients: BmTransferClient[];
  dry_run: boolean;
}

export const transferBmClients = async (
  source_bm_contact: string,
  dest_bm_contact: string,
  dry_run: boolean = false
): Promise<BmTransferResult | null> => {
  try {
    return await axios
      .post(`${process.env.REACT_APP_API_URL}/bm/transfer-clients/`, {
        source_bm_contact,
        dest_bm_contact,
        dry_run,
      })
      .then((res) => {
        if (!dry_run) message.success("Clients transferred successfully");
        return res?.data as BmTransferResult;
      })
      .catch((e) => {
        const err = e?.response?.data?.error;
        if (typeof err === "string") {
          message.error(err);
        } else {
          errorActions(e, "Error transferring clients. Please try again");
        }
        return null;
      });
  } catch (error) {
    return null;
  }
};

export const fetchUserPermissions = async () => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/user-permission/`)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorActions(
          error,
          "Error fetching user permissions. Please check and try again"
        );
        return;
      });
  } catch (error) {
    return [];
  }
};

export const fetchBranchTerms = async (branch_id: string) => {
  try {
    return axios
      .get(
        `${process.env.REACT_APP_API_URL}/terms-and-condition/` +
          "?branch=" +
          branch_id
      )
      .then((res) => {
        return res?.data;
      })
      .catch((error) => {
        errorActions(
          error,
          "Error fetching branch terms. Please check and try again"
        );
        return;
      });
  } catch (error) {
    return [];
  }
};

// Pincode Admin APIs
export const fetchPincodes = async (params?: any) => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/pincode-admin/`, {
        params: { ...params },
      })
      .then((res) => {
        return res?.data ?? { count: 0, results: [] };
      })
      .catch((error) => {
        errorActions(error, "Error fetching pincodes. Please try again");
        return { count: 0, results: [] };
      });
  } catch (error) {
    return { count: 0, results: [] };
  }
};

export const addPincode = async (values: any): Promise<boolean> => {
  try {
    return await axios
      .post(`${process.env.REACT_APP_API_URL}/pincode-admin/`, values)
      .then(() => {
        message.success("Pincode added successfully");
        return true;
      })
      .catch((e) => {
        const msg = e?.response?.data?.message;
        if (typeof msg === "string") {
          message.error(msg);
        } else {
          errorActions(e, "Error adding pincode. Please try again");
        }
        return false;
      });
  } catch (error) {
    return false;
  }
};

export const updatePincode = async (values: any): Promise<boolean> => {
  try {
    return await axios
      .put(`${process.env.REACT_APP_API_URL}/pincode-admin/`, values)
      .then(() => {
        message.success("Pincode updated successfully");
        return true;
      })
      .catch((e) => {
        const msg = e?.response?.data?.message;
        if (typeof msg === "string") {
          message.error(msg);
        } else {
          errorActions(e, "Error updating pincode. Please try again");
        }
        return false;
      });
  } catch (error) {
    return false;
  }
};

export const fetchDeliveryZones = async () => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/delivery-zone-list/`)
      .then((res) => {
        return res?.data ?? [];
      })
      .catch((error) => {
        errorActions(error, "Error fetching delivery zones");
        return [];
      });
  } catch (error) {
    return [];
  }
};

export const fetchZoneChoices = async () => {
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/zone-choices/`)
      .then((res) => {
        return res?.data ?? [];
      })
      .catch((error) => {
        errorActions(error, "Error fetching zone choices");
        return [];
      });
  } catch (error) {
    return [];
  }
};
